// import router from '@/router';
import axios from "axios";
import { useUserStore } from "@/stores/UserStore";
import router from "@/router";
export const appAxios = axios.create({
  baseURL: "http://localhost:3000",
});
export const bamsAxios = axios.create({
  baseURL: "https://api.quatrobilisim.com/api",
});
export const soapAxios = axios.create({
  baseURL:
    "https://osb-mwwebgate.ibb.gov.tr/External/TopluUlasim/TopluUlasimService/ProxyService/TopluUlasimServiceSOAPPS?wsdl",
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE",
    "Access-Control-Allow-Headers": "Content-Type",
    "Content-Type": "text/xml",
  },
});
export const mdmAxios = axios.create({
  baseURL: "/headwind/rest",
});
export const apiAxiosQuatro = axios.create({
  baseURL: "https://api.quatrobilisim.com/api",
});
export const firmwareAxiosQuatro = axios.create({
  baseURL: "https://api.quatrobilisim.com/firmware",
});
export const nodeApiAxiosQuatro = axios.create({
  baseURL: "https://telemetri.quatrobilisim.com",
});
export const tariffServiceApiAxiosQuatro = axios.create({
  baseURL: "https://quatro-tariff-service.quatrobilisim.com",
});
export const mdmServiceApiAxiosQuatro = axios.create({
  baseURL: "https://mdm-service.mobilulasim.com",
});
export const integrationApiAxiosTuhim = axios.create({
  baseURL: "https://tuhim-integration.mobilulasim.com",
});
nodeApiAxiosQuatro.interceptors.response.use(
  (response) => {
    return Promise.resolve(response);
  },
  async (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        const userStore = useUserStore();
        await userStore.logout();
        router.replace("/login");
      }
    }
    return Promise.reject(error);
  },
);
apiAxiosQuatro.interceptors.response.use(
  (response) => {
    return Promise.resolve(response);
  },
  async (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        const userStore = useUserStore();
        await userStore.logout();
        router.replace("/login");
      }
    }
    return Promise.reject(error);
  },
);
mdmServiceApiAxiosQuatro.interceptors.response.use(
  (response) => {
    return Promise.resolve(response);
  },
  async (error) => {
    if (error.response) {
      if (error.response.status === 403 || error.response.status === 401) {
        const userStore = useUserStore();
        await userStore.authenticateHeadwind();
        // isteği tekrar gönder --- IGNORE ---
        const originalRequest = error.config;
        originalRequest.headers[
          "Authorization"
        ] = `Bearer ${await userStore.getHeadwindToken}`;
        return mdmServiceApiAxiosQuatro(originalRequest);
      }
    }
    return Promise.reject(error);
  },
);
